import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import { useTranslation } from "react-i18next";
import Layout from "../../../components/Layout";
import LeaderViewPage from "../../../components/Pages/StaffManagement/View";

const { displayName } = config;

export default function StaffManagementView(): React.ReactNode | null {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Staff Management view`;
  }, []);

  return (
    <Layout>
      <LeaderViewPage />
    </Layout>
  );
}
